export default __webpack_public_path__ + "static/media/phoneCard.baab327c.svg";